import { Col, Flex, Form, Modal, Popconfirm, Row, Spin } from "antd";
import { FormItem } from "./components/FormItem/FormItem";
import { MyButton } from "../MyButton/MyButton";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MyModalFormProps } from "./MyModalForm.props";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";
import { selectStore } from "../../../store/selector";
import { MaterialIcon, TasksIcon, TestsIcon } from "../../../assets";
import { MyText } from "../MyText/MyText";
import { createSearchParams, generatePath, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { COMPONENT_TYPES_ENUM, FORM_FORM_TYPE, ROUTE_PATH } from "../../../constants";

const FORM_NAME = {
  JOURNAL_BALL: 'JOURNAL_BALL',
}

export const MyModalForm = ({
  title,
  visible,
  onCancel,
  onFinish,
  onDelete = () => {
  },
  state,
  formState,
  period,
  form,
  formName,
  modalClassName = 'modal-restore',
  extraFieldsArr = [],
  onValuesChange = (changedFields, allFields) => {
  },
}: MyModalFormProps) => {

  let submitLabel = state?.data[0]?.submit_label
  let prependItem = state?.data[0]?.prepend
  let isDelete = state?.data[0]?.is_delete_action
  let fieldsArr = state?.data[0]?.fields || []
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams()
  const {
    journal: { sdotResultByMark: sdotResultByMarkState },
  }: RootState = useSelector(selectStore)

  const [isSubmitButtonDisable, setIsSubmitButtonDisable] = useState<boolean>(false)

  const resetFieldHandler = useCallback(() => {
    onCancel(form)
    form.resetFields()
  }, [form])

  const onValuesChangeHandler = (changedFields: any, allFields: any) => {
    onValuesChange(changedFields, allFields)

    checkIsDisableButton(allFields)
  }

  const checkIsDisableButton = (values: any = {}) => {
    const array = [...fieldsArr, ...extraFieldsArr].filter(field => field.type !== 9).filter(field => field.is_required).map(field => ({
      name: field.name,
      isValidate: !!values[field.name]
    }))

    let res = !(array.every(field => field.isValidate))

    setIsSubmitButtonDisable(res)
  }

  useEffect(() => {
    if (Object.values(form?.getFieldsValue())?.length) {
      checkIsDisableButton(form.getFieldsValue())

      fieldsArr?.forEach((item: any) => {
        if (item.type === COMPONENT_TYPES_ENUM.TYPE_SELECT) {
          let current = form.getFieldsValue()?.[item.name]
          let currentValue = item?.fieldValues?.find((item: any) => item?.label === current)

          if (currentValue) {
            form.setFieldsValue({ [item.name]: currentValue?.value })
          }
        }
      })
    }
  }, [form.getFieldsValue()])

  const modalContent = useMemo(() => {
    const journalBallRender = (value: any, name: string) => {
      const item = {
        material: {
          icon: <MaterialIcon style={{ color: value?.percent == 0 ? 'rgba(250, 173, 20, 1)' : 'rgba(78, 175, 81, 1)' }} />,
          label: 'МАТЕРИАЛЫ',
          link: FORM_FORM_TYPE.MATERIALS
        },
        task: {
          icon: <TasksIcon style={{ color: value?.percent == 0 ? 'rgba(250, 173, 20, 1)' : 'rgba(78, 175, 81, 1)' }} />,
          label: 'ЗАДАНИЯ',
          link: FORM_FORM_TYPE.TASKS
        },
        test: {
          icon: <TestsIcon style={{ color: value?.percent == 0 ? 'rgba(250, 173, 20, 1)' : 'rgba(78, 175, 81, 1)' }} />,
          label: 'ТЕСТЫ',
          link: FORM_FORM_TYPE.TESTS
        },
      }

      const handleClick = () => {
        // @ts-ignore
        let sdot_type = item?.[name]?.link
        let student_id = formState?.record?.id
        let lesson_id = formState?.item?.lesson_id || formState?.column?.lesson_id

        // @ts-ignore
        const path = {
          pathname: generatePath(ROUTE_PATH.JOURNAL_SDOT, { id: lesson_id }),
          // @ts-ignore
          search: createSearchParams({
            sdotType: sdot_type,
            studentId: student_id,
            ctpId: params.id,
          }).toString(),
        }

        navigate(path)
      }

      return (
        value &&
        <Col span={24}>
          <div style={{
            border: '1px solid rgba(255, 255, 255, 1)',
            borderRadius: 4,
            padding: '6px 20px'
          }}>
            <Row align='middle' justify='space-between'>
              <Col>
                <Row align='middle' gutter={[10, 10]}>
                  <Col>
                    <Flex style={{
                      borderRadius: '50%',
                      width: 28,
                      height: 28,
                      backgroundColor: value?.percent == 0 ? 'rgba(254, 243, 220, 1)' : 'rgba(230, 243, 229, 1)'
                    }} justify='center' align='center'>
                      {/*// @ts-ignore*/}
                      {item?.[name]?.icon}
                    </Flex>
                  </Col>

                  <Col>
                    <MyText>
                      {/*// @ts-ignore*/}
                      {item?.[name]?.label}
                    </MyText>
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row align='middle' gutter={[10, 10]}>
                  <Col>
                    <MyText>
                      {value?.value}
                    </MyText>
                  </Col>

                  <Col>
                    <MyButton onClick={handleClick} icon={<RightOutlined />} type={'text'} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      )
    }

    switch (formName) {
      case FORM_NAME.JOURNAL_BALL:
        return (
          <Spin spinning={sdotResultByMarkState.loading}>
            <Row style={{ marginBottom: 16 }}>
              {journalBallRender(sdotResultByMarkState.data?.material, 'material')}
              {journalBallRender(sdotResultByMarkState.data?.task, 'task')}
              {journalBallRender(sdotResultByMarkState.data?.test, 'test')}
            </Row>
          </Spin>
        )
      default:
        return false
    }
  }, [sdotResultByMarkState])

  return (
    <Modal
      title={title}
      open={visible}
      centered
      destroyOnClose
      footer={null}
      width={800}
      className={modalClassName}
      onCancel={resetFieldHandler}
      forceRender
    >
      <Spin spinning={state?.loading}>
        <Form
          name={formName}
          form={form}
          onFinish={(values) => {
            onFinish(values)
          }}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            flex: 1,
          }}
          labelAlign='left'
          scrollToFirstError
          layout="horizontal"
          labelWrap
          colon={false}
          onValuesChange={(changedFields, allFields) => onValuesChangeHandler(changedFields, allFields)}
        >

          {prependItem ? <div dangerouslySetInnerHTML={{ __html: prependItem }} /> : null}

          {modalContent}

          {
            fieldsArr?.map((item: any, index: any) => (
              <FormItem
                key={index} item={item} object={{
                  ...state?.data[0],
                  start_date: period?.start_date,
                  end_date: period?.end_date,
                }} />
            ))
          }

          {
            extraFieldsArr?.map((item: any, index: any) => (
              <FormItem
                key={index} item={item} object={{
                  ...state?.data[0],
                  start_date: period?.start_date,
                  end_date: period?.end_date,
                }} />
            ))
          }

          <Row gutter={16} justify='center'>
            <Col>
              <Form.Item>
                <MyButton title={submitLabel ? submitLabel : "Сохранить"} htmlType="submit"
                  disabled={isSubmitButtonDisable} />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item>
                <MyButton title='Отменить' htmlType="reset" onClick={resetFieldHandler} />
              </Form.Item>
            </Col>

            {
              isDelete &&

              <Col>
                <Form.Item>
                  <Popconfirm
                    title="Удалить"
                    description="Вы уверены что хотите удалить?"
                    onConfirm={onDelete}
                    onCancel={resetFieldHandler}
                    okText="Да"
                    cancelText="Нет"
                  >
                    <MyButton title='Удалить' danger />
                  </Popconfirm>
                </Form.Item>
              </Col>
            }
          </Row>
        </Form>
      </Spin>
    </Modal>
  )
}